import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import LoanService from "../services/LoanService";

const initialState = {
    loanProducts: [],
    loanApplication: {},
    isLoading: true,
};

export const createLoan = createAsyncThunk(
    "loans/create",
    async ({data}) => {
        const res = await LoanService.createLoan(data);
        return res.data;
    }
);

export const getLoanProducts = createAsyncThunk(
    "loans/getLoanProducts",
    async () => {
        try {
            const res = await LoanService.getLoanProducts();
            return res.data;
        } catch (e) {
            console.log("Failed to get loan products due to: \n", e);
        }
    }
);

const loanSlice = createSlice({
    name: "loan",
    initialState,
    reducers: {
        newLoan: (state, action) => {
            state.loanApplication = action.payload;
            createLoan(state.loanApplication);
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getLoanProducts.pending, (state) => {
            state.isLoading = true;
        }).addCase(getLoanProducts.fulfilled, (state, action) => {
            // console.log(action);
            state.isLoading = false;
            state.loanProducts = action.payload;
        }).addCase(getLoanProducts.rejected, (state, action) => {
            console.log(action);
            state.isLoading = false;
        });
    }
});

export const {newLoan} = loanSlice.actions;
export default loanSlice.reducer;
